import { render, staticRenderFns } from "./OrganizationModuleForm.vue?vue&type=template&id=278d93a9&"
import script from "./OrganizationModuleForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationModuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports